import { Component, OnInit } from '@angular/core';
import { IPartialHeaderData } from "../../../../shared/services/header.service";
import { BaseBulkSendForSigningComponent } from "../base-bulk-send-for-signing/base-bulk-send-for-signing.component";
import { CheckboxComponent } from "@shared/controls/checkbox/checkbox.component";
import { DividerComponent } from "@shared/components/commons/divider/divider.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoaderComponent } from "@shared/components/commons/loader/loader.component";
import { TextareaComponent } from "@shared/controls/textarea/textarea.component";
import { RouterLink } from "@angular/router";
import {
  ListGridClientSideComponent
} from "@shared/components/grid/components/list-grid-client-side/list-grid-client-side.component";
import { annualStatementsQueryParamKey } from "../../../../shared/constants/query-param-keys.constant";

@Component({
  selector: 'app-bulk-send-annual-statement-for-signing',
  standalone: true,
  imports: [
    CheckboxComponent,
    DividerComponent,
    FormsModule,
    LoaderComponent,
    ReactiveFormsModule,
    TextareaComponent,
    RouterLink,
    ListGridClientSideComponent
  ],
  templateUrl: './bulk-send-annual-statement-for-signing-page.component.html',
  styleUrl: '../../styles/bulk-send-for-signing.scss'
})
export class BulkSendAnnualStatementForSigningPageComponent extends BaseBulkSendForSigningComponent implements OnInit {
  override readonly headerData: IPartialHeaderData = {
    title: 'Bulk Send Annual Statements for Signing',
    subtitle: 'Please enter the signatories contact details',
    iconClass: 'ic-bulk-changes-20'
  };
  override readonly queryParamKey = annualStatementsQueryParamKey;
}
